import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import useInvoiceAmount from "./useInvoiceAmount";
import { FormSectionHeader, Loader } from "@/components";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: "index" as const,
    intersection: false,
  },
  plugins: {
    legend: {
      position: "top" as const,
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
      },
      tooltip: {
        usePointStyle: true,
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: "Amount ($)", // 👈 your Y-axis label text
        color: "#666",
        font: {
          size: 14,
          weight: "bold",
        },
      },
    },
    x: {
      title: {
        display: true,
        text: "Months", // 👈 X-axis label (optional)
        color: "#666",
        font: {
          size: 14,
          weight: "bold",
        },
      },
    },
  },
};

const InvoiceAmount = ({ filterData }: any) => {
  const { isReportChartLoading, chartData } = useInvoiceAmount({ filterData });

  return isReportChartLoading ? (
    <Loader />
  ) : (
    <>
      <FormSectionHeader className="text-[20px] text-primary">
        Invoice Amount
      </FormSectionHeader>
      <Bar options={options as any} data={chartData} />
    </>
  );
};

export default InvoiceAmount;
